import { Detour } from '../apis/api-goodtoknow.js';
import { Place } from '../apis/api-places.js';
import { Accommodation, Bicycle, Slowup, Station, Swisspark, } from '../apis/api-poi.js';
import { Sightseeing } from '../apis/api-sightseeings.js';
import { Travelreport } from '../apis/api-travelreports.js';
import { getLanguageCode } from '../i18n.js';
import { disableMapKvp$, modal$ } from '../stores/store-main.js';
import { landUrlFragment, overlayDirectUrlFragment, } from '../urlHandling/urlParams.js';
import { isPOIOverlay } from '../helpers/constants.js';
import { createSightseeingPlaceUrl, createPointOfInterestUrl, } from '../urlHandling/urlCreate.js';
import { Subscription } from 'rxjs';
export function registerModalObserver() {
    const subscription = new Subscription();
    subscription.add(modal$.subscribe((options) => {
        if (isPOIOverlay(options)) {
            options = options;
            const lang = getLanguageCode();
            let layer;
            if (options.data instanceof Place)
                layer = overlayDirectUrlFragment.place[lang];
            else if (options.data instanceof Sightseeing)
                layer = overlayDirectUrlFragment.sightseeing[lang];
            else if (options.data instanceof Accommodation)
                layer = overlayDirectUrlFragment.accommodation[lang];
            else if (options.data instanceof Detour)
                layer = overlayDirectUrlFragment.detour[lang];
            else if (options.data instanceof Swisspark)
                layer = overlayDirectUrlFragment.swisspark[lang];
            else if (options.data instanceof Station)
                layer = overlayDirectUrlFragment.station[lang];
            else if (options.data instanceof Slowup)
                layer = overlayDirectUrlFragment.slowup[lang];
            else if (options.data instanceof Bicycle)
                layer = overlayDirectUrlFragment[options.data.type][lang];
            else if (options.type === 'travelreport' &&
                options.data.travelreport instanceof Travelreport) {
                layer = overlayDirectUrlFragment.travelreport[lang];
            }
            if (layer) {
                disableMapKvp$.next(true);
                if (options.type === 'sightseeing' || options.type === 'place') {
                    window.history.replaceState({}, '', createSightseeingPlaceUrl(options.data.title, lang, layer, options.data.id));
                }
                else if (options.type === 'travelreport') {
                    if (options.data.segment) {
                        const land = landUrlFragment[options.data.segment.land][lang];
                        window.history.replaceState({}, '', `/${lang}/${land}/${layer}-${options.data.travelreport.id}`);
                    }
                }
                else {
                    const id = options.data instanceof Slowup
                        ? options.data.refid
                        : options.data.id;
                    window.history.replaceState({}, '', createPointOfInterestUrl(lang, layer, id));
                }
            }
        }
    }));
    return subscription;
}
//# sourceMappingURL=modalObserver.js.map